module.exports = __webpack_public_path__ + "static/media/youtube.27d42ab2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/youtube.svg
// module id = 620
// module chunks = 0